var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero is-primary is-small"},[_c('div',{staticClass:"hero-body has-text-centered"},[_vm._v("© 2015 Sigma Web")])])}]

export { render, staticRenderFns }